import { useState } from 'react'

import { IconMenu2 } from '@tabler/icons-react'
import { sortBy } from 'lodash'

import type { Container as ContainerType } from 'lib/container'
import { getContainers } from 'lib/containers'

import { ButtonIcon } from 'components/Buttons'

import { Link } from '../Link'
import { Container } from './Container'
import { Entry } from './Entry'
import { FloatingGroup } from './FloatingGroup'
import { OrderedList } from './OrderedList'
import { Title } from './Title'

type Props = {
	pageName: string
}

const priority = [
	'Docs/QuickStart',
	'Docs/Transactions',
	'Docs/Transactions/PartnerApi',
	'Docs/Transactions/Sftp',
	'Docs/UserDetails',
	'Docs/Budgets',
	'Docs/Budgets/Findings',
	'Docs/Bridges',
	'Docs/Bridges/Android',
	'Docs/Bridges/Ios',
	'Docs/Bridges/Javascript',
	'Docs/FinanceData',
	'Docs/FinanceData/Categorization',
	'Docs/FinanceData/Mcp',
]

const hiddenFromSidebar = [
	'Docs/FinanceData/Mcp/ChatGpt',
	'Docs/FinanceData/Mcp/Codex',
	'Docs/FinanceData/Mcp/ClaudeCode',
	'Docs/FinanceData/Mcp/ClaudeDesktop',
	'Docs/FinanceData/Mcp/Cursor',
	'Docs/FinanceData/Mcp/Grok',
	'Docs/FinanceData/Mcp/Lovable',
	'Docs/FinanceData/Mcp/Tools',
	'Docs/FinanceData/Mcp/TryIt',
	'Docs/FinanceData/Mcp/VsCode',
	'Docs/FinanceData/Mcp/OtherClients',
	'Docs/FinanceData/Mcp/Troubleshooting',
]

export const Articles = ({ pageName }: Props) => {
	const [isMenuVisible, setIsMenuVisible] = useState(false)
	const containers = getContainers<ContainerType>()
	const pageRoot = pageName.split('/').length > 1 ? pageName.split('/')[0] : pageName
	const rootArticle = containers[pageRoot]
	const articles = sortBy(
		Object.entries(containers)
			.filter(([key]) => key.includes(pageRoot) && key !== pageRoot && !hiddenFromSidebar.includes(key))
			.flatMap(([key, value]) => {
				const priorityIndex = priority.findIndex((route) => key === route)

				return {
					title: value.navTitle,
					pageName: key,
					path: value.path,
					sortKey: `${(priorityIndex === -1 ? 99_999 : priorityIndex).toString().padStart(5, '0')}-${key}`,
					level: key.split('/').length - pageRoot.split('/').length,
				}
			}),
		({ sortKey }) => sortKey,
	)

	return (
		<>
			<Container style={{ left: isMenuVisible ? 0 : '-280px' }}>
				<Title>
					<Link name={pageRoot} activeMatch='exact'>
						{rootArticle.navTitle}
					</Link>
				</Title>
				<OrderedList>
					{articles.map(({ title, pageName, level }, index) => (
						<Entry key={index} level={level}>
							<Link name={pageName} activeMatch='page'>
								{title}
							</Link>
						</Entry>
					))}
				</OrderedList>
			</Container>
			<FloatingGroup>
				<ButtonIcon icon={<IconMenu2 />} onClick={() => setIsMenuVisible(!isMenuVisible)} />
			</FloatingGroup>
		</>
	)
}
